export const breakpoints = {
  sm: `(max-width: 520px)`,
  mds: `(max-width: 744px)`,
  md: `(max-width: 1190px)`,
};
